import './assets/scss/theme.scss';
import './assets/scss/user.scss';

import AppProvider from './providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from './providers/BreakpointsProvider';
import SettingsPanelProvider from './providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from './Routes';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppProvider>
      <SettingsPanelProvider>
        <BreakpointsProvider>
          <RouterProvider router={router} />
        </BreakpointsProvider>
      </SettingsPanelProvider>
    </AppProvider>
  </React.StrictMode>
);
